<template lang="html">
  <div class="custom-manual-wrapper">
    <Cropper
      v-if="mainP || pic"
      :src="imageForCropp"
      :extension="extension"
      @cropp="croppImage"
      @giveup="giveup"
    />
    <Cropper v-if="false" :src="xxxx" @cropp="croppImage" @giveup="giveup" />

    <div class="header">
      {{ $t('main.imagesSection') }}
    </div>

    <div class="info">
      <span class="info-key">
        {{ $t('profile.purchase.main_image') }} :
        <questionmark :id="18" />
      </span>
      <span class="info-value">
        <label for="main_image" class="btn">{{
          $t('profile.purchase.choose')
        }}</label>
        <input
          style="display: none;"
          ref="main_image"
          id="main_image"
          accept=".png, .jpg, .jpeg"
          type="file"
          @change="changeMainImage($event.target.files)"
        />
      </span>
    </div>
    <div
      v-if="main_image.images && main_image.images.length > 0"
      class="preview"
    >
      <div
        @click="removeImage(img, 'main_image')"
        v-for="img in main_image.images"
        :key="img + Math.random()"
        class="img-wrapper"
      >
        <img :src="img.src" alt="" />
        <div class="remove">
          {{ $t('item.remove') }}
        </div>
      </div>
    </div>
    <div class="info back">
      <span class="info-key">*{{ $t('details.details.imageSizeError') }}</span>
    </div>

    <div class="info">
      <span class="info-key">
        {{ $t('profile.purchase.images') }} :
        <questionmark :id="20" />
      </span>
      <span
        v-if="images.images && images.images.length < 14"
        class="info-value"
      >
        <label for="images" class="btn">{{
          $t('profile.purchase.choose')
        }}</label>
        <input
          style="display: none;"
          ref="images"
          accept=".png, .jpg, .jpeg"
          id="images"
          type="file"
          @change="changeImages($event.target.files)"
        />
      </span>
    </div>
    <div v-if="images.images && images.images.length > 0" class="preview">
      <div
        @click="removeImage(img, 'images')"
        v-for="img in images.images"
        :key="img + Math.random()"
        class="img-wrapper"
      >
        <img :src="img.src" alt="" />
        <div class="remove">
          {{ $t('item.remove') }}
        </div>
      </div>
    </div>
    <div class="info back">
      <span class="info-key">*{{ $t('details.details.imagesSizeError') }}</span>
    </div>

    <div class="info">
      <span class="info-key">
        {{ $t('profile.purchase.pro_quality') }} :
        <questionmark :id="21" />
      </span>
      <span class="info-value">
        <label v-if="numProofQuality < 5" for="pro_quality" class="btn">{{
          $t('profile.purchase.choose')
        }}</label>
        <input
          style="display: none;"
          ref="pro_quality"
          accept=".png, .jpg, .jpeg"
          id="pro_quality"
          type="file"
          @change="changeImagesQuality($event.target.files)"
        />
      </span>
    </div>
    <div
      v-if="pro_quality.images && pro_quality.images.length > 0"
      class="preview"
    >
      <div
        @click="removeImage(img, 'pro_quality')"
        v-for="img in pro_quality.images"
        :key="img + Math.random()"
        class="img-wrapper"
      >
        <img :src="img.src" alt="" />
        <div class="remove">
          {{ $t('item.remove') }}
        </div>
      </div>
    </div>
    <div class="info back">
      <span class="info-key"
        >*{{ $t('details.details.imagesSizeQuality') }}</span
      >
    </div>

    <div v-for="input in inputs" :key="input.name" class="info-wrapper">
      <div v-if="input.type === 'header'" class="header">
        {{ $t('main.' + input.value) }}
        <questionmark v-if="input.questionmark" :id="input.questionmark" />
      </div>
      <div v-else class="info">
        <span class="info-key">
          {{ $t('profile.purchase.' + input.name) }} :
          <questionmark v-if="input.questionmark" :id="input.questionmark" />
        </span>
        <span v-if="input.type === 'text'" class="info-value">
          <input
            :maxlength="input.length"
            type="text"
            @change="emitChange(input.name, $event.target.value)"
          />
        </span>
        <span v-else-if="input.type === 'checkbox'" class="info-value">
          <input
            type="checkbox"
            @change="emitChange(input.name, $event.target.checked)"
          />
        </span>
        <span v-else-if="input.type === 'dropdown'" class="info-value">
          <dropdown
            :defaultText="$t('profile.purchase.choose')"
            :selected="input.value"
            :list="input.dropdownList"
            :removable="true"
            @remove="emitChange(input.name, null), (input.value = null)"
            @changeOption="
              emitChange(input.name, $event.value), (input.value = $event)
            "
          />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Questionmark from '@/components/questionmark.vue'
import eventBus from '@/shared/eventBus.js'
import { api } from '@/api'
import Dropdown from '@/components/dropdown.vue'
import Cropper from './cropper'
import xxxx from '../../assets/images/logo.png'
import helper from '@/js/helper.js'
export default {
  name: 'detailsInfo',
  components: {
    Dropdown,
    Cropper,
    Questionmark
  },
  props: {
    params: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      xxxx: xxxx,
      main_image: {
        name: 'main_image',
        type: 'file',
        images: null
      },
      images: {
        name: 'images',
        type: 'file',
        images: [],
        files: []
      },
      pro_quality: {
        name: 'pro_quality',
        type: 'file',
        images: null,
        files: []
      },
      inputs: [
        {
          type: 'header',
          value: 'localSection'
        },
        {
          name: 'pro_shipping_info',
          type: 'text',
          length: 1100,
          questionmark: 44
        },
        {
          name: 'pro_shipping_time',
          type: 'text',
          length: 1100,
          questionmark: 36
        },
        {
          name: 'pro_seller_shipping',
          type: 'checkbox'
        },
        {
          name: 'pro_free_shipping',
          type: 'checkbox'
        },
        {
          name: 'pro_shipping_included',
          type: 'checkbox'
        },
        {
          name: 'pro_shipping_additional',
          type: 'text',
          length: 1100,
          questionmark: 16
        },
        {
          type: 'header',
          value: 'international',
          questionmark: 29
        },
        {
          name: 'pro_international_shipping',
          type: 'text',
          length: 1100,
          questionmark: 37
        },
        {
          type: 'header',
          value: 'transportSection'
        },
        {
          name: 'trc_id',
          type: 'dropdown',
          value: null,
          dropdownList: [],
          questionmark: 45
        },
        {
          name: 'trc_id_naval',
          type: 'dropdown',
          value: null,
          dropdownList: [],
          questionmark: 46
        }
      ],
      mainP: false,
      pic: false,
      imageForCropp: null,
      temporarilyPicName: '',
      numProofQuality: 0,
      extension: ''
    }
  },
  mounted () {
    this.getTransportDropdowns()
    this.getTransportNavalDropdowns()
    eventBus.$on('fixPreviews', data => {
      this[data.key].images = this.createPreviews(data.value)
      // this.$refs.main_image.value = null
    })
  },
  methods: {
    croppImage (e) {
      // console.log(e)
      // this.main = false
      // this.emitChange('main_image', files[0])
      if (this.mainP) {
        this.main_image.images = []
        this.main_image.images.push({ name: this.temporarilyPicName, src: e })
        this.emitChange(
          'main_image',
          helper.base64toFile(e, this.temporarilyPicName)
        )
      }
      if (this.pic) {
        // this.images.files.push(files[0])
        // let data = {
        //   key: 'images',
        //   value: this.images.files
        // }
        // eventBus.$emit('changeNewAdParams', data)
        this.images.images.push({ name: this.temporarilyPicName, src: e })
        this.images.files.push(helper.base64toFile(e, this.temporarilyPicName))
        console.log(e)
        console.log(helper.base64toFile(e, this.temporarilyPicName))
        let data = {
          key: 'images',
          value: this.images.files
        }
        eventBus.$emit('changeNewAdParams', data)
        console.log('image cropp')
        // console.log(this.images.images[0].src)
      }
      this.mainP = false
      this.pic = false
      this.imageForCropp = null
      this.$refs.main_image.value = null
      this.temporarilyPicName = ''
    },
    giveup () {
      this.mainP = false
      this.pic = false
      this.imageForCropp = null
      this.$refs.main_image.value = null
      this.temporarilyPicName = ''
    },
    changeMainImage (files) {
      if (files.length > 0) {
        // if (files[0].size > 409600) {
        //   this.$toast.error(this.$t('details.details.imageSizeError'), {
        //     duration: 8000
        //   })
        //   this.$refs.main_image.value = null
        //   return
        // }
        // this.emitChange('main_image', files[0])
        //  this.main_image.images = this.createPreviews(files)
        let reader = new FileReader()
        reader.onload = e => {
          // this.imgs.push(e.target.result)
          this.imageForCropp = e.target.result
          this.temporarilyPicName = Math.random() + files[0].name
          console.log()
          this.extension = files[0].type
          // console.log('name---' + files[0].name)
          console.log(files[0])
          if (this.imageForCropp !== null) {
            this.mainP = true
          }
        }
        reader.readAsDataURL(files[0])
      }
    },
    changeImages (files) {
      console.log(files[0])
      if (files.length === 0) {
        return
      }
      // if (files[0].size > 409600) {
      //   this.$toast.error(this.$t('details.details.imageSizeError'), {
      //     duration: 8000
      //   })
      //   this.$refs.images.value = null
      //   return
      // }
      let reader = new FileReader()
      reader.onload = e => {
        // this.imgs.push(e.target.result)
        this.imageForCropp = e.target.result
        this.temporarilyPicName = Math.random() + files[0].name
        this.extension = files[0].type
        if (this.imageForCropp !== null) {
          this.pic = true
        }
      }
      reader.readAsDataURL(files[0])
      /// / ////
      // this.images.files.push(files[0])
      // let data = {
      //   key: 'images',
      //   value: this.images.files
      // }
      // eventBus.$emit('changeNewAdParams', data)
      // this.images.images = this.createPreviews(this.images.files)
    },
    changeImagesQuality (files) {
      console.log('asd ')
      if (files.length === 0) {
        return
      }
      if (files[0].size > 1024 * 2000) {
        this.$toast.error(this.$t('details.details.imagesSizeQuality'), {
          duration: 8000
        })
        this.$refs.pro_quality.value = null
        return
      }
      this.pro_quality.files.push(files[0])
      let data = {
        key: 'pro_quality',
        value: this.pro_quality.files
      }
      this.numProofQuality++
      eventBus.$emit('changeNewAdParams', data)
      this.pro_quality.images = this.createPreviews(this.pro_quality.files)
    },
    createPreviews (images) {
      let res = []
      for (var i = 0; i < images.length; i++) {
        // console.log(images[i])
        let obj = {
          name: images[i].name
        }
        var oFReader = new FileReader()
        oFReader.readAsDataURL(images[i])

        oFReader.onload = function (oFREvent) {
          obj.src = oFREvent.target.result
          res.push(obj)
        }
      }
      return res
    },
    deletePreviews (name) {
      for (var i = 0; i < this.images.images.length; i++) {
        console.log(this.images.images[i].name)
        if (this.images.images[i].name === name) {
          this.images.images.splice(i, 1)
        }
      }
      console.log('this.images.images.length' + this.images.images.length)
    },
    removeImage (img, input) {
      if (input === 'images') {
        this.deletePreviews(img.name)
      }
      if (input === 'pro_quality') {
        // this.numProofQuality--
        this.numProofQuality -= 1
      }
      let data = {
        key: input,
        value: img.name
      }
      eventBus.$emit('changeNewAdImage', data)
    },
    getTransportDropdowns () {
      let params = { type: 1 }
      api
        .getTransportDropdowns(params)
        .then(res => {
          for (var i = 0; i < this.inputs.length; i++) {
            if (this.inputs[i].name === 'trc_id') {
              this.inputs[i].dropdownList = this.fixDropdownData(
                res.data.data,
                'transport'
              )
            }
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    getTransportNavalDropdowns () {
      let params = { type: 2 }
      api
        .getTransportDropdowns(params)
        .then(res => {
          for (var i = 0; i < this.inputs.length; i++) {
            if (this.inputs[i].name === 'trc_id_naval') {
              this.inputs[i].dropdownList = this.fixDropdownData(
                res.data.data,
                'transport'
              )
            }
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    fixDropdownData (data, type) {
      let res = []
      if (type === 'transport') {
        for (var i = 0; i < data.length; i++) {
          let obj = {
            label: data[i].trc_code,
            value: data[i].trc_id
          }
          res.push(obj)
        }
      }
      return res
    },
    emitChange (key, value) {
      console.log(value)
      let data = {
        key: key,
        value: value
      }
      eventBus.$emit('changeNewAdParams', data)
    },
    fixImagesArray (key, value) {
      let arr = []
      for (var i = 0; i < value.length; i++) {
        arr.push(value[i])
      }
      let data = {
        key: key,
        value: arr
      }
      eventBus.$emit('changeNewAdParams', data)
    }
  }
}
</script>

<style lang="scss" scoped>
input {
  height: 40px;
  border: 1px solid #e8e8e8;
  padding-left: 5px;
}
input:focus {
  outline: none;
}
.custom-manual-wrapper {
  padding: 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(243, 243, 243, 0.5);
  box-sizing: border-box;
  box-shadow: 0px 4px 7px rgba(0, 0, 0, 0.08);

  @import '@/assets/scss/btnStyles.scss';

  .preview {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-top: 25px;
    margin-bottom: 25px;

    .img-wrapper:hover {
      cursor: pointer;
      .remove {
        opacity: 0.5;
      }
    }
    .remove {
      opacity: 0;
      transition-duration: 0.3s;
    }
    img {
      height: auto;
      width: auto;
      max-height: 100px;
      max-width: 100px;
      border-radius: 5px;
      margin-right: 5px;
      margin-bottom: 5px;
    }
  }
  .header {
    text-align: left;
    margin-top: 20px;
    margin-bottom: 30px;
    font-size: 18px;
    border-bottom: 1px solid $main-color;
  }
  .info.back {
    margin-top: -25px;
  }
  .info {
    margin-bottom: 25px;
    display: flex;
    flex-direction: row;
    align-items: center;
    text-align: left;
    flex-wrap: wrap;

    .info-key {
      font-weight: normal;
      font-size: 13px;
      line-height: 21px;
      color: #787878;
      margin-right: 15px;
      // white-space: nowrap;
      min-width: 150px;
    }
    .info-value {
      font-weight: 800;
      font-size: 13px;
      line-height: 21px;
      letter-spacing: 0.02em;
      color: $text-color;
      display: flex;
      align-items: center;
      flex-grow: 1;

      input[type='file'] {
        height: auto;
        border: none;
      }
      textarea {
        width: 100%;
        border: 1px solid #dfdfdf;
        outline: none;
        resize: none;
        margin-top: 5px;
      }
      input[type='text'] {
        width: 100%;
      }
      input[type='checkbox'] {
        margin-left: auto;
      }
    }
    .info-value.wide {
      width: 100%;
    }
    .info-value.prices {
      display: flex;
      flex-direction: row;
      align-items: center;
      * {
        margin-right: 10px;
      }
      input {
        width: 60px;
      }
      .btn {
        width: 100px;
      }
    }
  }
}
input {
  height: 40px;
  border: 1px solid #e8e8e8;
  padding-left: 5px;
}
input:focus {
  outline: none;
}
@import '@/assets/scss/btnStyles.scss';

.info {
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: left;
  .info-key {
    font-weight: normal;
    font-size: 13px;
    line-height: 21px;
    color: #787878;
    margin-right: 0px;
    // white-space: nowrap;
    white-space: initial;
  }
  .info-value {
    font-weight: 800;
    font-size: 13px;
    line-height: 21px;
    letter-spacing: 0.02em;
    color: $text-color;
  }
}
</style>
